import { MapPin } from "lucide-react";

export function AddressMap({ address, className = "" }: { address?: string; className?: string }) {
  if (!address) return null;
  const q = encodeURIComponent(address);
  return (
    <div className={`overflow-hidden rounded-sm border border-white/10 ${className}`} data-testid="address-map">
      <iframe
        title="Plan d'accès NMS"
        src={`https://www.google.com/maps?q=${q}&output=embed`}
        className="h-48 w-full grayscale invert-[0.9] contrast-[0.9]"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <a href={`https://www.google.com/maps/search/?api=1&query=${q}`} target="_blank" rel="noreferrer"
        className="flex items-center gap-2 bg-[#121212] px-3 py-2 text-xs text-white/70 transition-colors hover:text-white" data-testid="address-map-link">
        <MapPin className="h-3.5 w-3.5 text-[#E63946]" />Ouvrir dans Google Maps
      </a>
    </div>
  );
}
